import { styled } from '@openeducation/pp-rn-themes';
import React, { memo, ReactNode } from 'react';
import { Button, ButtonProps } from 'react-native-paper';
export interface PPButtonProps extends Omit<ButtonProps, 'theme' | 'icon'> {
  icon?: string | ReactNode;
}

export const PPButton = ({ mode = 'contained', icon, children, ...props }: PPButtonProps) => {
  if (typeof icon === 'string' || icon === undefined) {
    return <StyledButton mode={mode} icon={icon} {...props}>{children}</StyledButton>;
  }

  return (
    <StyledButton mode={mode} {...props}>
      <ContentWrapper>
        <IconWrapper>
          {icon}
        </IconWrapper>
        {children}
      </ContentWrapper>
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  border-radius: ${({ theme }) => theme.border.radius.primary}px;
`;

const ContentWrapper = styled.View`
  flex-direction: row;
  align-items: center;
`;

const IconWrapper = styled.View`
  margin-right: ${({ theme }) => theme.spacing.tiny}px;
`;

export default memo(PPButton);
